// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/chunk/" + "my-notifications" + "." + "9da85f93253749837aa0" + ".css";
};